import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useModals } from "../../store/dialogs/hooks";
import { Transition } from "../../pages/app/utils/animation";
import { Warning } from "@mui/icons-material";

export const ClipImportWarningDialog = ({ handleSubmit, warningMessage }) => {
  const { closeClipImportWarningDialog, showClipImportWarningDialog } =
    useModals();
  const handleClose = () => closeClipImportWarningDialog();

  return (
    <Dialog
      aria-labelledby="clip-warning-dialog-title"
      aria-describedby="clip-warning-dialog-description"
      closeAfterTransition={false}
      onClose={handleClose}
      open={showClipImportWarningDialog}
      maxWidth="xs"
      slots={{
        transition: Transition,
      }}
      keepMounted
    >
      <DialogTitle
        id="clip-warning-dialog-title"
        display="flex"
        alignItems="center"
        gap={0.5}
      >
        <Warning color="warning" fontSize="medium" />
        Warning
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="clip-warning-dialog-description">
          {warningMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} autoFocus>
          continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
